import { PortalContext } from "@/context/PortalContext";
import * as React from "react";

export function useTitle(title: string) {
	const portalContext = React.useContext(PortalContext);
	const fullTitle = React.useMemo(() => {
		if (portalContext.pagePrefix) {
			return `${portalContext.pagePrefix}${title}`;
		}
		return title;
	}, [title, portalContext.pagePrefix]);

	React.useEffect(() => {
		if (fullTitle !== document.title) {
			document.title = fullTitle;
		}
	}, [fullTitle]);
}
